import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type { JetCallReportStatus } from 'pages/Jet/shared/constants/status'

export type JetCallReportStatusCount = {
  status: JetCallReportStatus
  count: number
}

export type GetJetCallReportStatusSummaryRequest = {
  // 0 means no limit ("Forever"); the backend treats it as unbounded.
  daysAgo?: number | null
}

export type GetJetCallReportStatusSummaryResponse = {
  items: JetCallReportStatusCount[]
}

// Returns the count of CDS work items in each JetCallReportStatus.
export const getJetCallReportStatusSummary = async (
  request: GetJetCallReportStatusSummaryRequest = {}
): Promise<GetJetCallReportStatusSummaryResponse> => {
  const params = {
    days_ago: request.daysAgo,
  }

  const response = await api.get<GetJetCallReportStatusSummaryResponse>(
    '/admin/jet/call_reports/status_summary',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
